
import instImg1 from "../images/instragram/1.jpg"
import instImg2 from "../images/instragram/2.jpg"
import instImg3 from "../images/instragram/3.jpg"
import instImg4 from "../images/instragram/4.jpg"
import instImg5 from "../images/instragram/5.jpg"
import instImg6 from "../images/instragram/6.jpg"
import instImg7 from "../images/instragram/7.jpg"
import instImg8 from "../images/instragram/8.jpg"
import instImg9 from "../images/instragram/70.jpg"
import instImg10 from "../images/instragram/71.jpg"
import instImg11 from "../images/instragram/72.png"
import instImg12 from "../images/instragram/73.png" 
import instImg13 from "../images/instragram/74.png"
import instImg14 from "../images/instragram/75.png"

const Instagram = [
    {
        id:"1",
        imag:instImg11,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"2",
        imag:instImg12,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"3",
        imag:instImg13,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"4",
        imag:instImg14,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"1",
        imag:instImg2,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"2",
        imag:instImg1,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"3",
        imag:instImg3,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"4",
        imag:instImg4,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"5",
        imag:instImg5,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"10",
        imag:instImg10,
        title: 'Charity',
        subtitle: 'Clean Water',
    },
     
    {
        id:"6",
        imag:instImg6,
        title: 'Charity',
        subtitle: 'Pure Water Supply',
    },
    {
        id:"7",
        imag:instImg7,
        title: 'Charity',
        subtitle: 'Health & Hope',
    },
    {
        id:"8",
        imag:instImg8,
        title: 'Charity',
        subtitle: 'Clean Water',
    },
      {
        id:"9",
        imag:instImg9,
        title: 'Charity',
        subtitle: 'Clean Water',
    },
      
]

export default Instagram;